<style scoped>
    @import "./index.css";
</style>
<template>
    <div id="layout-container">

        <!--<Tabs type="card" value="1">-->
            <!--<TabPane label="系统消息" name="1"></TabPane>-->
            <!--<TabPane label="报修消息" name="2"></TabPane>-->
        <!--</Tabs>-->
        <Tabs type="card" value="1">
            <TabPane label="消息中心" name="1"></TabPane>
        </Tabs>

        <!--列表-->
        <DragableTable
                refs="table"
                :loading="loading"
                :columns-list="columns"
                v-model="data"
        ></DragableTable>
        <!--列表 end-->
        <!--分页-->
        <Row id="tf-page" type="flex" align="middle" justify="space-between">
            <Col></Col>
            <Col>
                <Page :total="total" :page-size="pageSize" @on-change="onChangePage" @on-page-size-change="onChangeSizePage" show-elevator show-sizer></Page>
            </Col>
        </Row>
        <!--分页 end-->

        <!--右侧弹出窗口-->
        <Drawer title="查看消息" width="400" v-model="show">
            <div v-html="content"></div>
        </Drawer>


        <!--右侧弹出窗口-->
        <Drawer title="报修详情" width="400" v-model="show2">
            <ul class="hxz-list-grout mt20">
                <li class="list">
                    <div class="list-item flex flex-middle flex-between">
                        <label class="title">订单号</label>
                        <span class="right-txt">{{details.orderNo}}</span>
                    </div>
                </li>
                <li class="list">
                    <div class="list-item flex flex-middle flex-between">
                        <label class="title">设备分类</label>
                        <span class="right-txt">{{details.catName}}</span>
                    </div>
                </li>
                <li class="list">
                    <div class="list-item flex flex-middle flex-between">
                        <label class="title">设备名称</label>
                        <span class="right-txt">{{details.deviceName}}</span>
                    </div>
                </li>
                <li class="list">
                    <div class="list-item flex flex-middle flex-between">
                        <label class="title">提交时间</label>
                        <span class="right-txt">{{details.addTime}}</span>
                    </div>
                </li>
                <li class="list">
                    <div class="list-item flex flex-middle flex-between">
                        <label class="title">报修状态</label>
                        <span v-if="details.repairStatus == 1" class="right-txt">已提交</span>
                        <span v-if="details.repairStatus == 2" class="right-txt">处理中</span>
                        <span v-if="details.repairStatus == 3" class="right-txt">已修复</span>
                    </div>
                </li>
                <li class="list">
                    <div class="list-item">
                        <label class="title">请详细说明</label>
                    </div>
                    <p class="paragraph mt15">{{details.repairContent}}</p>
                </li>
            </ul>
        </Drawer>

    </div>

</template>

<script>
    import { DragableTable } from "@/views/Components/Table";
    import baoXiu from "./baoxiu";

    export default {
        name: "add",
        components: {
            DragableTable,
            baoXiu
        },
        data() {
            return {
                show2:false,
                details:'',

                loading:true,
                columns: [
                    {
                        title: "标题",
                        align:'left',
                        key: "messageTitle"
                    },
                    {
                        title: "内容",
                        key: "messageContent",
                        ellipsis:true
                    },
                    {
                        title: "状态",
                        key: "repairStatus", //（1-未处理 2-处理中 3-已处理）
                        render: (h, params) => {
                            if(params.row.repairStatus){
                                var _val = '',_type = '';
                                switch(params.row.repairStatus){
                                    case 1:
                                        _val  = '未处理';
                                        _type = 'error';
                                        break;
                                    case 2:
                                        _val = '处理中';
                                        _type = 'success';
                                        break;
                                    case 3:
                                        _val = '已修复';
                                        _type = 'primary';
                                        break;
                                }
                                return [
                                    h("Button", {
                                        props: {
                                            type: _type,
                                            size: 'small'
                                        }
                                    },_val)
                                ];
                            }else{
                                return h('span', '/');
                            }
                        }
                    },
                    {
                        title: "单号",
                        key: "orderNo",
                        render: (h, params) => {
                            if(params.row.orderNo){
                                return h('span', params.row.orderNo);
                            }else{
                                return h('span', '/');
                            }
                        }
                    },
                    {
                        title: "发布时间",
                        key: "addTime",
                        sortable: true
                    },
                    {
                        title: "操作",
                        align: "center",
                        render: (h, params) => {
                            if(params.row.repairStatus){ //报修
                                return [
                                    //查看
                                    h("Button", {
                                        props: {
                                            icon: "ios-search",
                                            type: "primary",
                                            size: 'small'
                                        },
                                        nativeOn: {
                                            click: () => {
                                                this.baoxiu(params)
                                            }
                                        }
                                    })
                                ];
                            }else{
                                return [
                                    //查看
                                    h("Button", {
                                        props: {
                                            icon: "ios-search",
                                            type: "primary",
                                            size: 'small'
                                        },
                                        nativeOn: {
                                            click: () => {
                                                this.showCon(params)
                                            }
                                        }
                                    })
                                ];
                            }
                        }
                    }
                ],
                data: [],

                //侧边弹出+步骤索引
                show:false,
                winTitle: "查看详情",
                content:'',

                //分页
                pageNum:1,
                pageSize:10,
                total:0
            };
        },
        created(){
            this.getData();
        },
        methods: {
            onChangePage(val){
                this.pageNum = val;
                this.getData();
            },
            onChangeSizePage(val){
                this.pageSize = val;
                this.getData();
            },
            //获取数据
            getData(){
                let that = this;
                this.loading = true;
                that.$func.ajax('myMessages',{
                    token :that.$func.getToken(),
                    pageNum: that.pageNum,
                    pageSize: that.pageSize,
                },function (r) {
                    if(!r.statusCode){
                        that.$func.msg(r.message,'error');
                    }else{
                        that.data  = r.pageInfo.list;
                        that.total = r.pageInfo.total;
                        that.loading = false;
                    }
                })
            },
            //查看报修
            baoxiu(params){
                let that = this;
                that.show2 = true;
                //获取详情
                that.$func.ajax('customerRepair',{
                    token :that.$func.getToken(),
                    repairId:params.row.messageId
                },function (r) {
                    if(!r.statusCode){
                        that.$func.msg(r.message,'error');
                    }else{
                        that.details = r.type;
                        that.details.repairStatus  = params.row.repairStatus;
                    }
                })
            },
            //查看
            showCon(params) {
                this.show = true;
                this.winTitle = params.row.messageTitle;
                this.content = params.row.messageContent;
            }
        }
    };
</script>
